export enum Role {
  ADMIN = 'rc_Administrator',
  STANDARD = 'rc_Standard User',
  LIMITED = 'rc_Limited User',
  CUSTOMER_USER = 'CARC_USER',
  CUSTOMER_ADMIN = 'CARC_ADMIN'
}

